import { NavLink, useNavigate } from "react-router-dom";
import {  useState } from "react";
import JobZImage from "../../../../common/jobz-img";
import {  publicUser } from "../../../../../globals/route-names";
import { useTranslation } from "react-i18next";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet-async';

function FrogotPasswordPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [step, setStep] = useState(1) // 1: email, 2: otp
    const [otp, setOtp] = useState('')
    const [token, setToken] = useState('')

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        // setMessage('');
        // setError('');

        // if (!email) return setError('Please enter your email.');

        if (!email) {
            toast.error('Please enter your email.');
            return;
        }

        try {
            const response = await axiosInstance.post(`${API_URL}/forgotPassword`, 
                { email }
            );
            const result = response.data;

            // setMessage(result.message || 'OTP sent to your email.');
            toast.success(result.message || 'OTP sent to your email.');
            setToken(result.token);
            setStep(2);

        } catch (err) {
            console.error(err);
            if (err.response) {
                toast.error(err.response.data.message || 'Something went wrong.');
            } else {
                toast.error('Something went wrong, please try again later.');
            }
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault()

        if (!otp) {
            toast.error('Please enter the OTP.');
            return;
        }

        try {
            const response = await axiosInstance.post(`${API_URL}/verifyOtp`,
                { token, otp }
            );

            toast.success(response.data.message || 'OTP verified successfully. You can now reset your password.');

            // If you want to navigate after success:
            navigate(`/reset-passwrod?email=${encodeURIComponent(email)}`);

        } catch (err) {
            console.error('Verify OTP Error:', err);

            if (err.response) {
                toast.error(err.response.data.message || 'Something went wrong.');
            } else {
                toast.error('Something went wrong, please try again later.');
            }
        }
    };

    return (
        <>
            <Helmet>
                <title>Forgot-Password | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="section-full site-bg-white">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                            <div style={{paddingTop: '0px'}} className="twm-log-reg-media">
                                <JobZImage src="images/login-bg.png" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-7">
                            <div className="twm-log-reg-form-wrap">
                                <div className="twm-log-reg-logo-head">
                                    <NavLink to={publicUser.HOME1}>
                                        <JobZImage src="images/skins-logo/logo-skin-5.png" alt="" className="logo" />
                                    </NavLink>
                                </div>
                                <div style={{paddingTop: '70px'}} className="twm-log-reg-inner">
                                    <div className="twm-log-reg-head">
                                        <span className="log-reg-form-title">{t("Forgot Password")}</span>
                                    </div>
                                    <div className="mt-3 mb-3">
                                        <span>{t("Enter your email and we’ll send you an OTP to reset your password.")}</span>
                                    </div>
                                    <div className="twm-tabs-style-2">
                                        <div className="tab-content">
                                            {/* {message && <Alert variant="success">{message}</Alert>}
                                            {error && <Alert variant="danger">{error}</Alert>} */}
                                            <form onSubmit={step === 1 ? handleEmailSubmit : handleOtpSubmit} className="tab-pane fade show active" id="twm-login-candidate">
                                                {step === 1 && (
                                                    <div className="form-group mb-3">
                                                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="emailInput">{t("Email")} :</label>
                                                        <input
                                                            id="emailInput"
                                                            name="Email"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={`${t("Enter your email")}*`}
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)} />
                                                    </div>
                                                )}
                                                {step === 2 && (
                                                    <div className="form-group mb-3">
                                                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="otpInput">{t("OTP")} :</label>
                                                        <input
                                                            id="otpInput"
                                                            name="otp"
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={`${t("Enter the OTP sent to your email")}*`}
                                                            value={otp}
                                                            onChange={(e) => setOtp(e.target.value)} />
                                                    </div>
                                                )}
                                                <div className="form-group">
                                                    <button type="submit" className="site-button">
                                                        {step === 1 ? `${t("Send OTP")}` : `${t("Verify OTP")}`}
                                                    </button>
                                                </div>
                                            </form>
                                            <div className='flex justify-center items-center site-text-primary mb-3'>
                                                <NavLink to={publicUser.pages.LOGIN}>
                                                    <i className="fa fa-arrow-left" />
                                                    <span className="site-text-primary ms-2">{t("Back to Login")}</span>
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></>
    );
}

export default FrogotPasswordPage;
